import {ArrUtil} from 'yougile-util'
import {Hub} from 'yougile-model'
import {Sync} from '@client/sync'

export const getAllowedMirroredHubs = (task: Hub): Hub[] | undefined => {
  const mirroredTasks = task?.data?.mirrors
  if (!mirroredTasks) {
    return undefined
  }

  const box = Sync.get(task)
  const rawList = mirroredTasks.map(taskId => box.getHub(taskId))
  const hubs = ArrUtil.filterUndefined(rawList)

  return hubs.filter(h => !h.deleted)
}
